import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getQuickLinksConsole = async (type: string, tenantid: string, roleid?: any) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/console-quicklinks?type=${type}&tenantid=${tenantid}${roleid ? `&roleid=${roleid}` : ''}`
  );

  return data;
};
